import { gql, useMutation } from "@apollo/client";

export const ADD_TRAININGS_BULK = gql`
  mutation AddTrainingsBulk($trainings: [TrainingInput!]!) {
    addTrainingsBulk(trainings: $trainings) {
      success
      errors
    }
  }
`;

export default function AddTrainingsBulkMutation() {
    const [mutate, { data, loading, error }] = useMutation(ADD_TRAININGS_BULK, {
        errorPolicy: "all",
    });
    return [mutate, { data, loading, error }];
}
